module.exports = __webpack_public_path__ + "static/media/katarina-icon.9b65db58.png";